import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { withEnvGuard } from '@traton/devportal-env-kit-app';

import { rootRouteRef, statusPageRouteRef } from './routes';
import {
  DeveloperPortalSupportAgentClient,
  developerPortalSupportAgentApiRef,
} from './api';

export const developerPortalSupportAgentPlugin = createPlugin({
  id: 'developer-portal-support-agent',
  apis: [
    createApiFactory({
      api: developerPortalSupportAgentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DeveloperPortalSupportAgentClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
    statusPage: statusPageRouteRef,
  },
});

export const DeveloperportalsupportagentPage =
  developerPortalSupportAgentPlugin.provide(
    createRoutableExtension({
      name: 'DeveloperportalsupportagentPage',
      component: () =>
        import('./views/ChatRoot').then(m =>
          withEnvGuard(m.ChatRoot, 'developer-portal-support-agent'),
        ),
      mountPoint: rootRouteRef,
    }),
  );

export const PortalAssistantIndexStatusPage =
  developerPortalSupportAgentPlugin.provide(
    createRoutableExtension({
      name: 'IndexStatusPage',
      component: () =>
        import('./views/IndexStatusPage').then(m =>
          withEnvGuard(m.IndexStatusPage, 'developer-portal-support-agent'),
        ),
      mountPoint: statusPageRouteRef,
    }),
  );
